import type { ComponentType } from 'react';
import { IconMobile, IconSignal, IconTrophy, IconStar, IconShield } from './NavIconSet';

interface IconProps {
  className?: string;
}

export const NAV_ICONS: Record<string, ComponentType<IconProps>> = {
  'icon-mobile': IconMobile,
  'icon-signal': IconSignal,
  'icon-trophy': IconTrophy,
  'icon-star': IconStar,
  'icon-shield': IconShield,
};

export function pickNavIcon(classes?: string): ComponentType<IconProps> | null {
  if (!classes) return null;
  for (const cls of classes.split(/\s+/)) {
    if (cls in NAV_ICONS) return NAV_ICONS[cls];
  }
  return null;
}
